import { format, formatInTimeZone } from "date-fns-tz";

export function formatDate(date = new Date(), formatStr = "yyyy-MM-dd HH:mm:ss", timeZone = "Asia/Jakarta") {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return formatInTimeZone(dateObj, timeZone, formatStr);
}

export const formatColumnValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return value === 0 ? "" : value.toLocaleString();
};

export function formatDateCalendar(
  date = new Date(),
  formatStr = "yyyy-MM-dd HH:mm:ss",
  timeZone = "utc"
) {
  const timeZoneMap = {
    wib: "Asia/Jakarta", // UTC+7
    wita: "Asia/Makassar", // UTC+8
    wit: "Asia/Jayapura", // UTC+9
    utc: "UTC",
  };

  const timeZoneKey = timeZone.toLowerCase();
  const tz = timeZoneMap[timeZoneKey] || "Asia/Jakarta";

  let dateObj;

  if (typeof date === "string") {
    dateObj = new Date(date);

    if (isNaN(dateObj?.getTime())) {
      const parts = date.split("-");
      if (parts.length === 3) {
        const [dd, mm, yyyy] = parts;
        dateObj = new Date(`${yyyy}-${mm}-${dd}`);
      }
    }
  } else {
    dateObj = date;
  }

  if (isNaN(dateObj?.getTime())) {
    dateObj = new Date();
  }

  return formatInTimeZone(dateObj, tz, formatStr);
}

export const formatDateTime = (date) => {
  const day = String(date.getDate()).padStart(2, "0"); // Mengambil tanggal dan menambahkan 0 jika kurang dari 10
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Mengambil bulan (0-indexed) dan menambahkan 0 jika kurang dari 10
  const year = date.getFullYear(); // Mengambil tahun
  const hours = String(date.getHours()).padStart(2, "0"); // Mengambil jam dan menambahkan 0 jika kurang dari 10
  const minutes = String(date.getMinutes()).padStart(2, "0"); // Mengambil menit dan menambahkan 0 jika kurang dari 10
  const seconds = String(date.getSeconds()).padStart(2, "0"); // Mengambil detik dan menambahkan 0 jika kurang dari 10

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getDateMonthYear = (dateString) => {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${year}-${month}-${day}`;
};
// Func untuk request TGL
export const getYMD = (dateString) => {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${year}-${month}-${day}`;
};
export const formatDateSave = (date) => {
  if (date == null || date == "0000-00-00") {
    date = new Date();
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateSaveFirst = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// export const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('id-ID', { style: 'decimal' }).format(amount);
// };

export const formatCurrency = (amount) => {
  if (amount === 0 || isNaN(amount)) {
    // Return '0' with separators for zero or invalid values
    return new Intl.NumberFormat("id-ID", { style: "decimal" }).format(0);
  } else {
    // Return formatted amount for non-zero values
    return new Intl.NumberFormat("id-ID", { style: "decimal" }).format(amount);
  }
};

export const getZFormat = (value) => {
  let formattedValue = String(value);
  if (formattedValue.includes(".00")) {
    formattedValue = formattedValue.replace(".00", "");
  }
  return formattedValue;
};

export const getZFormatWithDecimal = (value, decimal) => {
  let valueReturn = String(value);
  valueReturn = parseFloat(valueReturn).toFixed(decimal);
  return valueReturn;
};

export const formatRibuan = (number) => {
  if (number === undefined || number === null) {
    return "-";
  }
  return number.toLocaleString("id-ID");
};

export const formatDateTampil = (dateString) => {
  if (!dateString) return null;
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  let month = (dateObj.getMonth() + 1).toString();
  month = month.length === 1 ? "0" + month : month;
  let day = dateObj.getDate().toString();
  day = day.length === 1 ? "0" + day : day;
  return `${day}-${month}-${year}`;
};
// -----------------------------------------------------< Zona Waktu >

const timeZone = "Asia/Jakarta"; // Atur zona waktu Indonesia di sini

// -------------------------------------------------------< Exp >
// Fungsi untuk mengubah format tanggal dari "YYYY-MM-DD" menjadi "MM-YYYY"
export const formatTglExpiredOld = (tanggal) => {
  if (!tanggal) return ""; // Tambahkan pengecekan apakah tanggal adalah null atau tidak terdefinisi
  const [tahun, bulan, _] = tanggal.split("-");
  return `${bulan}-${tahun}`;
};

export const formatTglExpired = (tanggal) => {
  const date = new Date(tanggal);
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month < 10 ? "0" + month : month}-${year}`;
};

export const formatDatePdf = (date) => {
  const options = { day: "numeric", month: "long", year: "numeric" };
  return new Date(date).toLocaleDateString("id-ID", options);
};

export const formatAndSetDate = (inputValue, setFunction) => {
  let formattedValue = inputValue.replace(/[^0-9]/g, ""); // Remove non-numeric characters

  if (formattedValue.length > 0) {
    formattedValue = formattedValue.replace(/(\d{2})(\d{1,2})(\d{0,4})/, "$1-$2-$3"); // Add separators
  }

  // Update the calendar value based on the formatted date
  if (formattedValue.length === 10) {
    const [day, month, year] = formattedValue.split("-").map(Number);
    if (year >= 1000) {
      setFunction(new Date(year, month - 1, day));
    }
  }
};

export const subtractOneDay = (dateString) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() - 1); // Mengurangkan 1 hari dari tanggal
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const getNameMonth = (date) => {
  return new Intl.DateTimeFormat("id-ID", { month: "long", year: "numeric" }).format(date);
};

export const showSuccess = (toast, detail) => {
  toast.current.show({ severity: "success", summary: "Success Message", detail: detail, life: 3000 });
};

export const showError = (toast, detail) => {
  toast.current.show({ severity: "error", summary: "Error Message", detail: detail, life: 3000 });
};

export const rupiahConverter = (number = 0) => {
  const formattedNumber = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace("Rp", "Rp.");
};

export const uniqueId = (length) => Date.now().toString(36) + Math.random().toString(36).substr(2, length);

export function generateReferralCodeByUser() {
  const prefix = "REF";
  const date = new Date();
  const ymd = date.toISOString().slice(2, 10).replace(/-/g, ""); // yymmdd
  const random = Math.random().toString(36).substring(2, 7).toUpperCase(); // 5 karakter acak

  return `${prefix}${ymd}${random}`;
}
